export const languageURLKeys = [
  {key: 'arab', name: 'Arapça'},
  {key: 'en', name: 'İngilizce'},
  {key: 'fr', name: 'Fransızca'},
  {key: 'ger', name: 'Almanca'},
  {key: 'rus', name: 'Rusça'},
  {key: 'tr', name: 'Türkçe'},
]

export const genderURLKeys = [
  {key: 'erkek', name: 'MALE'},
  {key: 'kadin', name: 'FEMALE'},
]
